import styled from 'styled-components';
export var Content = styled('div').withConfig({
  displayName: "styled__Content",
  componentId: "sc-18nmlx4-0"
})(["margin:12px 24px 24px;display:flex;width:270px;flex-direction:column;"]);
export var CoordinateFields = styled('div').withConfig({
  displayName: "styled__CoordinateFields",
  componentId: "sc-18nmlx4-1"
})(["display:flex;flex-direction:column;margin-top:10px;"]);
export var CoordinateField = styled('div').withConfig({
  displayName: "styled__CoordinateField",
  componentId: "sc-18nmlx4-2"
})(["display:flex;flex-direction:row;align-items:center;margin-bottom:10px;"]);
export var DegreeContainer = styled('div').withConfig({
  displayName: "styled__DegreeContainer",
  componentId: "sc-18nmlx4-3"
})(["display:flex;flex-direction:column;margin-left:59px;margin-bottom:10px;"]);
export var CoordinateLabel = styled('div').withConfig({
  displayName: "styled__CoordinateLabel",
  componentId: "sc-18nmlx4-4"
})(["margin-right:5px;width:40px;display:flex;flex-direction:row;"]);
export var SelectField = styled('div').withConfig({
  displayName: "styled__SelectField",
  componentId: "sc-18nmlx4-5"
})(["margin-bottom:10px;display:flex;flex-direction:column;"]);
export var EmergencyInfoContainer = styled('div').withConfig({
  displayName: "styled__EmergencyInfoContainer",
  componentId: "sc-18nmlx4-6"
})(["margin-top:10px;"]);
export var SelectLabel = styled('div').withConfig({
  displayName: "styled__SelectLabel",
  componentId: "sc-18nmlx4-7"
})(["font-size:12px;margin-top:5px;opacity:0.8;"]);
export var ReverseGeoCodes = styled('div').withConfig({
  displayName: "styled__ReverseGeoCodes",
  componentId: "sc-18nmlx4-8"
})(["display:flex;flex-direction:column;margin-top:5px;"]);
export var Approximation = styled('span').withConfig({
  displayName: "styled__Approximation",
  componentId: "sc-18nmlx4-9"
})(["width:12px;font-size:14px;"]);